import { useEffect, useState } from "react";
import useDataBean from "../../../../../../core/services/dataBean/useDataBean";
import { _NationalizationProcessGeneralInfo } from "../../../../../../core/services/dataBean/EntityCatalogVdos";
import { Singleton } from "../../../../../../core/services/Singleton";
import { toast } from "react-toastify";
import { ListMenu } from "../../../../../theme/Component/ListMenu";
import { BasicPage } from "../../../../../theme/Component/BasicPage";
import { BasicTable, MASK_NUMBER } from "../../../../../theme/Component/BasicTable";
import { Modal } from "../../../../../theme/Component/Modal";
import { ModalConfirm } from "../../../../../theme/Component/ModalConfirm";
import { BasicButton } from "../../../../../theme/Component/BasicButton";
import { SelectAdquisitionContract } from "../../../../../RemoteAbstractAction/components/com/quickdataerp/actions/steps/SelectAdquisitionContract";
import { InputDate } from "../../../../../theme/Input/InputDate";
import { PaymentMethodSelect } from "../../../../../Talentohumano/PaymentMethod/PaymentMethodSelect";
import { SelectMonths } from "../../../../../contract/select/SelectMonths";
import { CurrencyEditor } from "../../../../../erp/cellEditor/Currency/CurrencyEditor";
import { AccountEditor } from "../../../../../editor/AccountEditor";
import { FileInput } from "../../../../../theme/Component/FileInput";
import { NationalizationProcessItemsBystudyCost } from "../NationalizationProcessItems/NationalizationProcessItemsBystudyCost";
import { NationalizationProcessItemsByStoreProduct } from "../NationalizationProcessItems/NationalizationProcessItemsByStoreProduct";
import { NationalizationProcessItemsByLiquidation } from "../NationalizationProcessItems/NationalizationProcessItemsByLiquidation";
import { NationalizationProcessItemsByActStore } from "../NationalizationProcessItems/NationalizationProcessItemsByActStore";
import { NationalizationProcessItemsByImportDM } from "../NationalizationProcessItems/NationalizationProcessItemsByImportDM";
import useModal, { MODAL_LG } from "../../../../../theme/Component/hooks/useModal";
import { DropDown } from "../../../../../theme/Component/DropDown";
import AutoChart from "../../../../../../core/graph/AutoChart";
import usePaginator from "../../../../../theme/Component/usePaginator";
import { SelectSiteID } from "../../../../../admin/configuracion/SiteID/SelectSiteID";
import { NationalizationProcessItemsBydescarguedirecto } from "../NationalizationProcessItems/NationalizationProcessItemsBydescarguedirecto";
import { _single } from "../../../../../../core/services/dataBean/EntityCatalog";
import { NationalizationSupport } from "./NationalizationSupport/NationalizationSupport";



export const NationalizationProcessGeneralInfo = () => {

    const generalinfobycost = useDataBean(_NationalizationProcessGeneralInfo);
    const single = Singleton.getInstance();
    const [state, setstate] = useState<any>('');
    const [statedos, setstatedos] = useState<any>('');
    const [option, setOption] = useState<number>(null);
    const [donation, setDonation] = useState<any>(false);
    const [contract, setContract] = useState<any>(false);
    const [accountemployee, setaccountemployee] = useState<any>(_single.getAccountID());
    const [lista, setLista] = useState<any>([]);
    const [appoGroup, setAppoGroup] = useState<number>(null)
    const [verdoc, setVerdoc] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modaleditarestudiocosto, setModaleditarestudiocosto] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modaleditarinventariomercancia, setModaleditarinventariomercancia] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modalitemsliquidacion, setModalitemsliquidacion] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modalitemscosto, setModalitemscosto] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modalitemsinventario, setModalitemsinventario] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modalitemsacta, setModalitemsacta] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modalitemsdeclaracion, setModalitemsdeclaracion] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modalitemsdescargue, setModalitemsdescargue] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modaleditarliquidacion, setModaleditarliquidacion] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modaleditaracta, setModaleditaracta] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modaleditardeclaracionimp, setModaldeclaracionimp] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modalrep, setModalrep] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modaldirecto, setModaldirecto] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modalverimage, setModalverimage] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modalC, setModalC] = useState<any>({ name: "Eliminar", tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-sm' });
    const modalGraphseeis = useModal("Grafica Declaracion de Importacion", MODAL_LG);
    const modalGraphcinco = useModal("Grafica Declaracion de Importacion", MODAL_LG);
    const modalGraphcuatro = useModal("Grafica Acta de Entrega de Mercancia", MODAL_LG);
    const modalGraphtres = useModal("Grafica Liquidacion de Costos de Importacion", MODAL_LG);
    const modalGraphdos = useModal("Grafica Inventario de Mercancia", MODAL_LG);
    const modalGraph = useModal("Grafica Estudio de Costos", MODAL_LG);
    const [pathfile, setPathFile] = useState<string>('');
    const paginador = usePaginator();
    useEffect(() => {
        getLista();
    }, [state, statedos])
    useEffect(() => {
        if(option == 200)//donacion
        {
            setContract("false");
            setDonation("true");
        }else if(option == 100){
            setContract("true");
            setDonation("false");
        }
    }, [option])
    const getLista = () => {

        generalinfobycost.instance.getNationalizationProcessGeneralInfoReport(paginador.page, 15, { "State": 1,"Contract":contract,"Donation":donation }).then(
            (resp: any) => {
                if (resp) {
                    paginador.setPages(resp.NumberOfPages);
                    paginador.setRecords(resp.NumberOfPages * 15);
                    paginador.setRegiPerPage(15);

                    // Procesamos cada item antes de setear la lista
                    const listaProcesada = resp.List.map((user: any) => {
                        user.DataBeanProperties.WarningTotalDaysToterminationstore = estadoFechaManifiesto(user.DataBeanProperties.ManifestDateINVM);
                        return user;
                    });

                    setLista(listaProcesada);
                }
            }
        );
    }
    const estadoFechaManifiesto = (fecha: any): string => {
        if (!fecha) return 'SIN FECHA';

        const fechaObjetivo = new Date(fecha);
        const hoy = new Date();

        // Ignorar la hora para comparar solo fechas
        fechaObjetivo.setHours(0, 0, 0, 0);
        hoy.setHours(0, 0, 0, 0);

        // Calcula diferencia en días: días transcurridos desde la fecha
        const diferenciaMs = hoy.getTime() - fechaObjetivo.getTime();
        const diferenciaDias = Math.floor(diferenciaMs / (1000 * 60 * 60 * 24));

        let message = '';

        if (diferenciaDias >= 0 && diferenciaDias < 20) {
            message = "<span class='text-success'>A TIEMPO</span>";
        } else if (diferenciaDias >= 20 && diferenciaDias < 30) {
            message = "<span class='text-warning'>SOLICITE PRÓRROGA</span>";
        } else if (diferenciaDias > 30) {
            message = "<span class='text-danger'>VENCIDA</span>";
        }

        message += ` (${diferenciaDias})`;
        return message;
    };

    

    const createestudiocosto = () => {
        generalinfobycost.setBean({
            Contract: contract,
            Donation: donation,
            State: 1,
            Since: _single.getCurrenDate(),
            IDEmployee: _single.getAccountID()
        });
        setModaleditarestudiocosto({ ...modaleditarestudiocosto, "view": true });
    }
    const createinventario = () => {
        generalinfobycost.setBean({
            Contract: contract,
            Donation: donation,
            State: 1,
            Since: _single.getCurrenDate(),
            IDEmployee: _single.getAccountID()
        });
        setModaleditarinventariomercancia({ ...modaleditarinventariomercancia, "view": true });
    }
    const createliquidacion = () => {
        generalinfobycost.setBean({
            State: 1,
            Since: _single.getCurrenDate(),
            IDEmployee: _single.getAccountID()
        });
        setModaleditarliquidacion({ ...modaleditarliquidacion, "view": true });
    }
    const createactamercancia = () => {
        generalinfobycost.setBean({
            State: 1,
            Since: _single.getCurrenDate(),
            IDEmployee: _single.getAccountID()
        });
        setModaleditaracta({ ...modaleditaracta, "view": true });
    }
    const createdeclaracionimportacion = () => {
        generalinfobycost.setBean({
            State: 1,
            Since: _single.getCurrenDate(),
            IDEmployee: _single.getAccountID()
        });
        setModaldeclaracionimp({ ...modaleditardeclaracionimp, "view": true });
    }
    const createacatadescargue = () => {
        generalinfobycost.setBean({
            State: 1,
            Since: _single.getCurrenDate(),
            IDEmployee: _single.getAccountID()
        });
        setModaldirecto({ ...modaldirecto, "view": true });
    }

    // const limpiar = () => {
    //     setDonation('false');
    //     setContract('false');
    //     setstate('false'); 
    //     setstatedos('false');
    // };
    const deleteItem = () => {
        generalinfobycost.bean.State = 2;
        //console.log(Project.bean);
        editaItem();
        setModalC({ ...modalC, "view": false });

    }
    const editaItem = () => {
        //console.log(entailment.bean);
        generalinfobycost.instance.updateNationalizationProcessGeneralInfo(generalinfobycost.bean).then(
            (resp: any) => {
                console.log(resp)
                getLista();
                setModaleditarestudiocosto({ ...modaleditarestudiocosto, "view": false });
                setModaleditarinventariomercancia({ ...modaleditarinventariomercancia, "view": false });
                setModaleditarliquidacion({ ...modaleditarliquidacion, "view": false });
                setModaleditaracta({ ...modaleditaracta, "view": false });
                setModaldeclaracionimp({ ...modaleditardeclaracionimp, "view": false });
                setModaldirecto({ ...modaldirecto, "view": false });
            }
        ).catch(err => {
            toast.error(err);
        })

    }


    const headcostoestudio = [
        { title: 'ID', property: 'IDNationalizationProcessGeneralInfo', visible: true },
        { title: 'Fecha del estudio de costos', property: 'DateEC', visible: true },
        { title: 'Responsable', property: 'AdquisitionContractName', visible: true },
        { title: 'No Contrato', property: 'NoContrato', visible: true },
        { title: 'Descripción del Contrato', property: 'ContractDescription', visible: true },
        { title: 'Tasa de cambio', property: 'ExchangeRate', visible: true },
        // { title: 'No. Documento Transporte', property: 'NoDocTransport', visible: true, mask: MASK_NUMBER },
        { title: 'Medio o Formas de pago', property: 'paymentMethodName', visible: true },
        { title: 'Comisión Forpo', property: 'ForpoComission', visible: true },
        { title: 'Lugar de entrega de la mercancia', property: 'DeliveryPlaceEC', visible: true },
        { title: 'Plazo para la entrega', property: 'DeliveryDeadlineEC', visible: true },
        { title: 'Mes de proyeccion de la entrega', property: 'ProjectionMonthEC', visible: true },
        { title: 'Descripción de la mercancia', property: 'MerchandiseDescriptionEC', visible: true },
        // { title: 'Tipo Moneda', property: 'currencyCode', visible: true },
        // { title: 'Fecha', property: 'Since', visible: true },
        // { title: 'Contrato', property: 'Contract', visible: false },
        // { title: 'Donación', property: 'Donation', visible: false },
        // { title: 'Nombre Contrato', property: 'ContractDescription', visible: true },
        // { title: 'Nombre Proyecto', property: 'ProjectDescription', visible: true },

    ]

    const headinventariomercacia = [
        { title: 'ID', property: 'IDNationalizationProcessGeneralInfo', visible: true },
        { title: 'Deposito de la mercancia', property: 'DepositINVM', visible: true },
        // { title: 'No. Inventarios de mercancía que se generan', property: 'NoInvetoryINVM', visible: true },
        // { title: 'Ciudad o direccion donde se encuentra el inventario', property: 'PlaceINVM', visible: true },
        { title: 'Lugar', property: 'PlaceINVM', visible: true },
        { title: 'Fecha', property: 'DateINVM', visible: true },
        { title: 'Documento Transporte', property: 'NoDocTransport', visible: true },
        { title: 'Numero de manifiesto de la carga', property: 'NoManifiestINVM', visible: true },
        { title: 'Fecha Manifiesto', property: 'ManifestDateINVM', visible: true },
        { title: 'Terminación Bodegaje', property: 'WarningTotalDaysToterminationstore', visible: true },
        { title: 'Asunto', property: 'DelegateINVM', visible: true },
        { title: 'Peso Bruto', property: 'GrossWeightINVM', visible: true },
        { title: 'Observaciones', property: 'ObservationsINVM', visible: true },

    ]

    const headliquidacion = [
        { title: 'ID', property: 'IDNationalizationProcessGeneralInfo', visible: true },
        { title: 'No. Documento Transporte', property: 'NoDocTransport', visible: true, mask: MASK_NUMBER },
        // { title: 'Tipo Moneda', property: 'currencyCode', visible: true },
        // { title: 'Fecha de liquidacion de costos de la importacion', property: 'LiquidationCostDateLC', visible: true },
        // { title: 'Fecha', property: 'Since', visible: true },
        // { title: 'Contrato', property: 'Contract', visible: false },
        // { title: 'Donación', property: 'Donation', visible: false },
        // { title: 'Nombre Contrato', property: 'ContractDescription', visible: true },
        // { title: 'Nombre Proyecto', property: 'ProjectDescription', visible: true },

    ]


    const headacta = [
        { title: 'ID', property: 'IDNationalizationProcessGeneralInfo', visible: true },
        { title: 'No. Documento Transporte', property: 'NoDocTransport', visible: true, mask: MASK_NUMBER },
        // { title: 'No. Acta de entrega de mercancia', property: 'NoDeliveryActEM', visible: true },
        { title: 'Fecha de registro de Entrega de Mercancia', property: 'DateEM', visible: true },
        { title: 'Deposito de entrega de Mercancia', property: 'DepositEM', visible: true },
        // { title: 'Ciudad', property: 'AdressEM', visible: true },
        { title: 'Dirección de entrega de Mercancia', property: 'AdressEM', visible: true },
        { title: 'Fecha de Entrega de la Mercancia', property: 'DeliveryDateEM', visible: true },
        { title: 'Fecha', property: 'Since', visible: true },
        { title: 'Contrato', property: 'Contract', visible: false },
        { title: 'Donación', property: 'Donation', visible: false },
        { title: 'Nombre Contrato', property: 'ContractDescription', visible: true },
        // { title: 'Nombre Proyecto', property: 'ProjectDescription', visible: true },
    ]



    const headdeclaracionimp = [
        { title: 'ID', property: 'IDNationalizationProcessGeneralInfo', visible: true },
        { title: 'No. Documento Transporte', property: 'NoDocTransport', visible: true, mask: MASK_NUMBER },
        { title: 'Fecha de declaración de importación', property: 'ImportDeclarationDateDM', visible: true },
        { title: 'Número de declaración de Importación', property: 'NoDeclartionImportDMStr', visible: true },
        { title: 'Fecha', property: 'Since', visible: true },
        { title: 'Contrato', property: 'Contract', visible: false },
        { title: 'Donación', property: 'Donation', visible: false },
        { title: 'Nombre Contrato', property: 'ContractDescription', visible: true },
        // { title: 'Nombre Proyecto', property: 'ProjectDescription', visible: true },
    ]


    const headactaescarguedirecto = [
        { title: 'ID', property: 'IDNationalizationProcessGeneralInfo', visible: true },
        { title: 'No. Documento Transporte', property: 'NoDocTransport', visible: true, mask: MASK_NUMBER },
        { title: 'Moneda', property: 'currencyCode', visible: true },
        { title: 'Ciudad', property: 'CityEDD', visible: true },
        // { title: 'Fecha de entrega', property: 'DateEDD', visible: true },
        { title: 'Fecha de entrega', property: 'DateEDD', visible: true },
        { title: 'Alamcenista', property: 'AccountStr', visible: true },
        { title: 'Profesión y Nombre de Coordinador (a) Grupo de Comercio Exterior', property: 'CoordinationExteriorComerceEDD', visible: true },
        { title: 'Fecha', property: 'Since', visible: true },
        { title: 'Contrato', property: 'Contract', visible: false },
        { title: 'Donación', property: 'Donation', visible: false },
        { title: 'Nombre Contrato', property: 'ContractDescription', visible: true },
        // { title: 'Nombre Proyecto', property: 'ProjectDescription', visible: true },

    ]

    // botones 

    const listaBotonescostoestudio = () => {
        const botones = [
            { titulo: 'Editar', icono: 'ri-edit-2-line', visible:  single.canEdit(), evento: () => { setModaleditarestudiocosto({ ...modaleditarestudiocosto, "view": true }) } },
            { titulo: 'Items', icono: 'ri-align-justify', visible:  single.canEdit(), evento: () => { setModalitemscosto({ ...modalitemscosto, "view": true }) } },
            { titulo: 'Documentos', icono: 'ri-edit-2-line', visible: single.canEdit(), evento: () => { setVerdoc({ ...verdoc, "view": true }) } },
            { titulo: 'Generar Reporte', icono: 'ri-folder-chart-line', visible: single.canDelete(), evento: () => { setModalrep({ ...modalrep, "view": true }) } },
            { titulo: 'Eliminar', icono: 'ri-delete-bin-line', visible: single.canDelete() && generalinfobycost.bean && accountemployee === generalinfobycost.bean.IDEmployee, evento: () => { setModalC({ ...modalC, "view": true }) } },

        ]
        return (
            <ListMenu listaBotones={botones} />
        )
    }


    const listaBotonesinventariomercancia = () => {
        const botones = [
            { titulo: 'Editar', icono: 'ri-edit-2-line', visible:  single.canEdit(), evento: () => { setModaleditarinventariomercancia({ ...modaleditarinventariomercancia, "view": true }) } },
            { titulo: 'Items', icono: 'ri-align-justify', visible:  single.canEdit(), evento: () => { setModalitemsinventario({ ...modalitemsinventario, "view": true }) } },
            { titulo: 'Documentos', icono: 'ri-edit-2-line', visible: single.canEdit(), evento: () => { setVerdoc({ ...verdoc, "view": true }) } },
            { titulo: 'Generar Reporte', icono: 'ri-folder-chart-line', visible: single.canDelete(), evento: () => { setModalrep({ ...modalrep, "view": true }) } },
            { titulo: 'Eliminar', icono: 'ri-delete-bin-line', visible: single.canDelete() && generalinfobycost.bean && accountemployee === generalinfobycost.bean.IDEmployee, evento: () => { setModalC({ ...modalC, "view": true }) } },

        ]
        return (
            <ListMenu listaBotones={botones} />
        )
    }



    const listaBotonesliquiedacion = () => {
        const botones = [
            // { titulo: 'Editar', icono: 'ri-edit-2-line', visible:  single.canEdit(), evento: () => { setModaleditarliquidacion({ ...modaleditarliquidacion, "view": true }) } },
            { titulo: 'Items', icono: 'ri-align-justify', visible:  single.canEdit(), evento: () => { setModalitemsliquidacion({ ...modalitemsliquidacion, "view": true }) } },
            { titulo: 'Documentos', icono: 'ri-edit-2-line', visible: single.canEdit(), evento: () => { setVerdoc({ ...verdoc, "view": true }) } },
            { titulo: 'Generar Reporte', icono: 'ri-folder-chart-line', visible: single.canDelete(), evento: () => { setModalrep({ ...modalrep, "view": true }) } },
            { titulo: 'Eliminar', icono: 'ri-delete-bin-line', visible: single.canDelete() && generalinfobycost.bean && accountemployee === generalinfobycost.bean.IDEmployee, evento: () => { setModalC({ ...modalC, "view": true }) } },

        ]
        return (
            <ListMenu listaBotones={botones} />
        )
    }



    const listaBotonesacta = () => {
        const botones = [
            { titulo: 'Editar', icono: 'ri-edit-2-line', visible:  single.canEdit(), evento: () => { setModaleditaracta({ ...modaleditaracta, "view": true }) } },
            { titulo: 'Items', icono: 'ri-align-justify', visible:  single.canEdit(), evento: () => { setModalitemsacta({ ...modalitemsacta, "view": true }) } },
            { titulo: 'Documentos', icono: 'ri-edit-2-line', visible: single.canEdit(), evento: () => { setVerdoc({ ...verdoc, "view": true }) } },
            { titulo: 'Imagenes', icono: 'ri-image-2-line', visible: single.canEdit(), evento: () => { setModalverimage({ ...modalverimage, "view": true }) } },
            { titulo: 'Generar Reporte', icono: 'ri-folder-chart-line', visible: single.canDelete(), evento: () => { setModalrep({ ...modalrep, "view": true }) } },
            { titulo: 'Eliminar', icono: 'ri-delete-bin-line', visible: single.canDelete() && generalinfobycost.bean && accountemployee === generalinfobycost.bean.IDEmployee, evento: () => { setModalC({ ...modalC, "view": true }) } },

        ]
        return (
            <ListMenu listaBotones={botones} />
        )
    }


    const listaBotonesdeclaracionimp = () => {
        const botones = [
            { titulo: 'Editar', icono: 'ri-edit-2-line', visible:  single.canEdit(), evento: () => { setModaldeclaracionimp({ ...modaleditardeclaracionimp, "view": true }) } },
            { titulo: 'Items', icono: 'ri-align-justify', visible:  single.canEdit(), evento: () => { setModalitemsdeclaracion({ ...modalitemsdeclaracion, "view": true }) } },
            { titulo: 'Documentos', icono: 'ri-edit-2-line', visible: single.canEdit(), evento: () => { setVerdoc({ ...verdoc, "view": true }) } },
            { titulo: 'Generar Reporte', icono: 'ri-folder-chart-line', visible: single.canDelete(), evento: () => { setModalrep({ ...modalrep, "view": true }) } },
            { titulo: 'Eliminar', icono: 'ri-delete-bin-line', visible: single.canDelete() && generalinfobycost.bean && accountemployee === generalinfobycost.bean.IDEmployee, evento: () => { setModalC({ ...modalC, "view": true }) } },

        ]
        return (
            <ListMenu listaBotones={botones} />
        )
    }

    const listaActadirecciondescargue = () => {
        const botones = [
            { titulo: 'Editar', icono: 'ri-edit-2-line', visible:  single.canEdit(), evento: () => { setModaldirecto({ ...modaldirecto, "view": true }) } },
            { titulo: 'Items', icono: 'ri-align-justify', visible:  single.canEdit(), evento: () => { setModalitemsdescargue({ ...modalitemsdescargue, "view": true }) } },
            { titulo: 'Documentos', icono: 'ri-edit-2-line', visible: single.canEdit(), evento: () => { setVerdoc({ ...verdoc, "view": true }) } },
            { titulo: 'Generar Reporte', icono: 'ri-folder-chart-line', visible: single.canDelete(), evento: () => { setModalrep({ ...modalrep, "view": true }) } },
            { titulo: 'Eliminar', icono: 'ri-delete-bin-line', visible: single.canDelete() && generalinfobycost.bean && accountemployee === generalinfobycost.bean.IDEmployee, evento: () => { setModalC({ ...modalC, "view": true }) } },

        ]
        return (
            <ListMenu listaBotones={botones} />
        )
    }

    const descargarReporte = (id: number) => {
        if (id == 1) {
            //exportExcelWithDataINVM
            generalinfobycost.instance.exportExcelWithDataINVM(generalinfobycost.bean.IDNationalizationProcessGeneralInfo).then(
                (resp: any) => {
                    // Extraer el ObjectValue
                    let fullPath = resp || "";
                    console.log(fullPath);
                    // Obtener solo el nombre del archivo
                    let fileName = fullPath.split("/").pop(); // Esto elimina toda la ruta y deja solo el nombre del archivo

                    console.log(fileName);

                    let path = "/quickdataerp/temp/docs/" + fileName;
                    setPathFile(path);
                }
            )
        }
        else if (id == 2) {
            //exportExcelWithDataEC
            generalinfobycost.instance.exportExcelWithDataEC(generalinfobycost.bean.IDNationalizationProcessGeneralInfo).then(
                (resp: any) => {
                    // Extraer el ObjectValue
                    let fullPath = resp || "";
                    console.log(fullPath);
                    // Obtener solo el nombre del archivo
                    let fileName = fullPath.split("/").pop(); // Esto elimina toda la ruta y deja solo el nombre del archivo

                    console.log(fileName);

                    let path = "/quickdataerp/temp/docs/" + fileName;
                    setPathFile(path);
                }
            );
        }
        else if (id == 3) {
            //exportExcelWithDataLC
            generalinfobycost.instance.exportExcelWithDataLC(generalinfobycost.bean.IDNationalizationProcessGeneralInfo).then(
                (resp: any) => {
                    // Extraer el ObjectValue
                    let fullPath = resp || "";
                    console.log(fullPath);
                    // Obtener solo el nombre del archivo
                    let fileName = fullPath.split("/").pop(); // Esto elimina toda la ruta y deja solo el nombre del archivo

                    console.log(fileName);

                    let path = "/quickdataerp/temp/docs/" + fileName;
                    setPathFile(path);
                }
            )
        }
        else if (id == 4) {
            //exportExcelWithDataEM
            generalinfobycost.instance.exportExcelWithDataEM(generalinfobycost.bean.IDNationalizationProcessGeneralInfo).then(
                (resp: any) => {
                    // Extraer el ObjectValue
                    let fullPath = resp || "";
                    console.log(fullPath);
                    // Obtener solo el nombre del archivo
                    let fileName = fullPath.split("/").pop(); // Esto elimina toda la ruta y deja solo el nombre del archivo

                    console.log(fileName);

                    let path = "/quickdataerp/temp/docs/" + fileName;
                    setPathFile(path);
                }
            )
        }
        else if (id == 5) {
            //exportExcelWithDataDM
            generalinfobycost.instance.exportExcelWithDataDM(generalinfobycost.bean.IDNationalizationProcessGeneralInfo).then(
                (resp: any) => {
                    // Extraer el ObjectValue
                    let fullPath = resp || "";
                    console.log(fullPath);
                    // Obtener solo el nombre del archivo
                    let fileName = fullPath.split("/").pop(); // Esto elimina toda la ruta y deja solo el nombre del archivo

                    console.log(fileName);

                    let path = "/quickdataerp/temp/docs/" + fileName;
                    setPathFile(path);
                }
            )
        }
        else if (id == 6) {
            //exportExcelWithDataDM
            generalinfobycost.instance.ExportExcelWithDataEDD(generalinfobycost.bean.IDNationalizationProcessGeneralInfo).then(
                (resp: any) => {
                    // Extraer el ObjectValue
                    let fullPath = resp || "";
                    console.log(fullPath);
                    // Obtener solo el nombre del archivo
                    let fileName = fullPath.split("/").pop(); // Esto elimina toda la ruta y deja solo el nombre del archivo

                    console.log(fileName);

                    let path = "/quickdataerp/temp/docs/" + fileName;
                    setPathFile(path);
                }
            )
        }
    }
    const actionsDropDown = [
        { id: 1, name: 'Reporte Grafico Estudio de Costos', permiso: null, activo: true },
        { id: 2, name: 'Reporte Grafico Inventario de Mercancia', permiso: null, activo: true },
        { id: 3, name: 'Reporte Grafico Liquidacion de Costos de Importacion', permiso: null, activo: true },
        { id: 4, name: 'Reporte Grafico Acta de Entrega de Mercancia', permiso: null, activo: true },
        { id: 5, name: 'Reporte Grafico Declaracion de Importacion', permiso: null, activo: true },

    ];

    const iconButtonsItemestudio = [
        { nombre: 'Agregar Estudio de Costos', visible: single.canCreate(), icono: 'ri-file-add-line', evento: createestudiocosto }
    ]
    const iconButtonsIteminventario = [
        { nombre: 'Agregar Inventario de Mercancia', visible: single.canCreate(), icono: 'ri-file-add-line', evento: createinventario }
    ]
    const iconButtonsItemliquidacion = [
        { nombre: 'Agregar Liquidacion de Costos', visible: single.canCreate(), icono: 'ri-file-add-line', evento: createliquidacion }
    ]
    const iconButtonsItemactamercancia = [
        { nombre: 'Agregar Acta de entrega de mercancia', visible: single.canCreate(), icono: 'ri-file-add-line', evento: createactamercancia }
    ]
    const iconButtonsItemdelaracion = [
        { nombre: 'Agregar Declaración de importación', visible: single.canCreate(), icono: 'ri-file-add-line', evento: createdeclaracionimportacion }
    ]
    const iconButtonsItemactadescarguedirecto = [
        { nombre: 'Agregar Acta de entrega descargue directo', visible: single.canCreate(), icono: 'ri-file-add-line', evento: createacatadescargue }
    ]
    const buttons = () => {
        return (
            <div className="row">
                <div className="col-md-12">
                    <DropDown lista={actionsDropDown} eventClick={(e) => {
                        if (e.id === 1) {

                            modalGraph.open();
                        } else if (e.id == 2) {
                            modalGraphdos.open();
                        }
                        else if (e.id == 3) {
                            modalGraphtres.open();
                        } else if (e.id == 4) {
                            modalGraphcuatro.open();
                        } else if (e.id == 5) {
                            modalGraphcinco.open();
                        } else if (e.id == 6) {
                            modalGraphcinco.open();
                        }
                    }}></DropDown>
                </div>
            </div>
        )
    }





    return (
        <BasicPage titulo="Tabla de Información General de Nacionalización">
            <div className="row">
                <div className="col-md-12">
                    <div className="row">


                        <div className="col-md-6">
                            <label>Elija una opción*</label>
                            <select
                                className="form-control"
                                value={option ?? ""}
                                onChange={(e: any) => {
                                    const value = Number(e.target.value);
                                    setOption(value);
                                }}
                            >
                                <option value="">...</option>
                                <option value={200}>Donación</option>
                                <option value={100}>Contrato</option>
                            </select>
                        </div>
                        {option === 200 && (
                            <>
                                <div className="col-md-6">
                                    <label>Tipo de formularios por Donación</label>
                                    <select className="form-control" value={state || ""}  onChange={(e: any) => { setstate(e.target.value); setstatedos(""); }} >
                                        <option value="false">...</option>
                                        <option value="2">Inventario de Mercancia</option>
                                        <option value="4">Declaración de importación</option>
                                        <option value="5">Acta de entrega de mercancia</option>
                                        <option value="6">Acta de entrega descargue directo</option>
                                    </select>
                                </div>
                                <div className="col-md-6 mt-4 p-2">
                                    <div className="row">

                                        <div className="col-md-6">
                                            <BasicButton icon="ri-search-eye-line" clase="btn rounded-pill btn-primary waves-effect waves-light" disable={!state} eventClick={getLista}>Buscar</BasicButton>
                                        </div>
                                    </div>


                                </div>

                            </>



                        )}

                        {option === 100 && (
                            <>

                                <div className="col-md-6">
                                    <label>Tipo de formularios por Contrato</label>
                                    <select className="form-control" value={statedos || ""}  onChange={(e: any) => { setstatedos(e.target.value); setstate(""); }} >
                                        <option value="false">...</option>
                                        <option value="1">Estudio de Costos</option>
                                        <option value="2">Inventario de Mercancia</option>
                                        <option value="3">Liquidacion de Costos</option>
                                        <option value="4">Declaración de importación</option>
                                        <option value="5">Acta de entrega de mercancia</option>
                                        <option value="6">Acta de entrega descargue directo</option>
                                    </select>
                                </div>
                                <div className="col-md-6 mt-4 p-2">
                                    <div className="row">

                                        <div className="col-md-6">
                                            <BasicButton icon="ri-search-eye-line" clase="btn rounded-pill btn-primary waves-effect waves-light" disable={!statedos} eventClick={getLista}>Buscar</BasicButton>
                                        </div>
                                    </div>


                                </div>
                            </>



                        )}

                    </div>
                </div>
            </div>


            <div className="row">

                {statedos == 1 && (
                    <div className="col-md-12">
                        <label>Estudio de Costos</label>
                        <BasicTable body={lista} head={headcostoestudio} rowSet={generalinfobycost.setBean} listButtons={listaBotonescostoestudio()} iconButtons={iconButtonsItemestudio} />
                        <Modal modal={verdoc} updateModal={setVerdoc}>
                            <>
                                <NationalizationSupport Nationalization={generalinfobycost.bean.IDNationalizationProcessGeneralInfo} />
                            </>
                        </Modal>
                        <Modal modal={modaleditarestudiocosto} updateModal={setModaleditarestudiocosto} eventModal={editaItem}>
                            <>
                                <div className="row">
                                    <div className="col-md-6">
                                        <AccountEditor idAccount={generalinfobycost.bean.IDAdquisitionContract} label="Responsable" onChange={(acc: any) => { generalinfobycost.setBean({ ...generalinfobycost.bean, "IDAdquisitionContract": acc.IDAccount }); }} />
                                    </div>
                                    <div className="col-md-6">
                                        <InputDate name="DateEC" label="Fecha del estudio de costos" value={generalinfobycost.bean.DateEC} setDate={(e: any) => { generalinfobycost.setBean({ ...generalinfobycost.bean, "DateEC": e }) }} />
                                    </div>
                                    <div className="col-md-6">
                                        <label>Firma</label>
                                        <input type="text" name="SignContract" className="form-control" value={generalinfobycost.bean.SignContract} onChange={generalinfobycost.handleChange} />
                                    </div>
                                    <div className="col-md-6">
                                        <label>No Contrato</label>
                                        <input type="text" name="NoContrato" className="form-control" value={generalinfobycost.bean.NoContrato} onChange={generalinfobycost.handleChange} />
                                    </div>
                                    <div className="col-md-12">
                                        <label>Descripción del Contrato</label>
                                        <textarea name="ContractDescription" className="form-control" value={generalinfobycost.bean.ContractDescription} onChange={(e) => { generalinfobycost.setBean({ ...generalinfobycost.bean, 'ContractDescription': e.target.value }) }} />
                                    </div>

                                    {/* <div className="col-md-6">
                                        <label>No. Documento Transporte</label>
                                        <input type="text" name="NoDocTransport" className="form-control" value={generalinfobycost.bean.NoDocTransport} onChange={generalinfobycost.handleChange} />
                                    </div> */}
                                    <div className="col-md-6">
                                        <label>Tasa de cambio</label>
                                        <input type='text' name="ExchangeRate" className="form-control" value={generalinfobycost.bean.ExchangeRate} onChange={generalinfobycost.handleChange} />
                                    </div>
                                    <div className="col-md-6">

                                        <label>Comision Forpo (%)</label>
                                        <input type="number" name="ForpoComission" className="form-control" value={generalinfobycost.bean.ForpoComission} onChange={generalinfobycost.handleChange} />

                                    </div>
                                    <div className="col-md-6">
                                        <label>Medio o Formas de pago</label>
                                        <PaymentMethodSelect idSelector={generalinfobycost.bean.PaymentMethodEC} onChange={(e) => { generalinfobycost.setBean({ ...generalinfobycost.bean, "PaymentMethodEC": e }) }} />
                                    </div>

                                    <div className="col-md-6">
                                        <label>Lugar de entrega de la mercancia</label>
                                        <input type="text" name="DeliveryPlaceEC" className="form-control" value={generalinfobycost.bean.DeliveryPlaceEC} onChange={generalinfobycost.handleChange} />
                                    </div>

                                    <div className="col-md-6">
                                        <label>Plazo de Entrega (Meses)</label>
                                        <input type="number" name="DeliveryDeadlineEC" className="form-control" value={generalinfobycost.bean.DeliveryDeadlineEC} onChange={generalinfobycost.handleChange} />
                                        {/* <InputDate name="DeliveryDeadlineEC" label="Plazo de Entrega" value={generalinfobycost.bean.DeliveryDeadlineEC} setDate={(e: any) => { generalinfobycost.setBean({ ...generalinfobycost.bean, "DeliveryDeadlineEC": e }) }} /> */}

                                    </div>
                                    <div className="col-md-6">
                                        <label>Mes de proyeccion de la entrega</label>
                                        <SelectMonths idSelector={generalinfobycost.bean.ProjectionMonthEC} onChange={(e: number) => { generalinfobycost.setBean({ ...generalinfobycost.bean, "ProjectionMonthEC": e }) }}></SelectMonths>
                                    </div>

                                    {/* <div className="col-md-6">
                                        <CurrencyEditor id={generalinfobycost.bean.CurrencyType} onchange={(e: any) => { generalinfobycost.setBean({ ...generalinfobycost.bean, "CurrencyType": e }) }}></CurrencyEditor>
                                    </div> */}
                                    {/* <div className="col-md-6">

                                        <label>Firma del estudio de costo</label>
                                        <input type="text" name="FirmEC" className="form-control" value={generalinfobycost.bean.FirmEC} onChange={generalinfobycost.handleChange} />

                                    </div> */}
                                    {/* <div className="col-md-12">
                                        <label>Observaciones con respecto al estudio de costos</label>
                                        <textarea name="ObservationsEC" className="form-control" value={generalinfobycost.bean.ObservationsEC} onChange={(e) => { generalinfobycost.setBean({ ...generalinfobycost.bean, 'ObservationsEC': e.target.value }) }} />
                                    </div> */}
                                    {/* <div className="col-md-6">
                                        <AccountEditor idAccount={generalinfobycost.bean.MadeByEC} label="USUARIO/PERSONAL que realiza el estudio de costos" onChange={(acc: any) => { generalinfobycost.setBean({ ...generalinfobycost.bean, "MadeByEC": acc.IDAccount }); }} />
                                    </div>
                                    <div className="col-md-6">
                                        <AccountEditor idAccount={generalinfobycost.bean.ReviewedByEC} label="USUARIO/PERONAL que hace la revisión del estudio de costos" onChange={(acc: any) => { generalinfobycost.setBean({ ...generalinfobycost.bean, "ReviewedByEC": acc.IDAccount }); }} />
                                    </div> */}
                                    <div className="col-md-12">
                                        <label>Descripción de la mercancia</label>
                                        <textarea name="MerchandiseDescriptionEC" className="form-control" value={generalinfobycost.bean.MerchandiseDescriptionEC} onChange={(e) => { generalinfobycost.setBean({ ...generalinfobycost.bean, 'MerchandiseDescriptionEC': e.target.value }) }} />
                                    </div>
                                </div>
                                {/* {generalinfobycost.bean.IDNationalizationProcessGeneralInfo &&
                                    <>
                                        <div className="row mt-4">
                                            <NationalizationProcessItemsBystudyCost IDNationalizationProcessGeneralInfo={generalinfobycost.bean.IDNationalizationProcessGeneralInfo} />
                                        </div>
                                    </>
                                } */}

                            </>
                        </Modal>
                        <Modal modal={modalrep} updateModal={setModalrep} eventModal={editaItem} evenOnClose={()=>{setPathFile('')}}>
                            <>
                                <div className="col-md-12">
                                    <BasicButton icon="" eventClick={() => { descargarReporte(2) }}>Estudio de Costos</BasicButton>
                                    {pathfile != '' &&
                                        <div className="col-md-12">
                                            <a href={pathfile} target="_blank">Descargar Archivo</a>
                                        </div>
                                    }
                                </div>

                            </>
                        </Modal>
                        <Modal modal={modalitemscosto} updateModal={setModalitemscosto}>
                            <>
                                <div className="row">
                                    <div className="col-md-12">
                                        <NationalizationProcessItemsBystudyCost IDNationalizationProcessGeneralInfo={generalinfobycost.bean.IDNationalizationProcessGeneralInfo} />
                                    </div>
                                </div>


                            </>
                        </Modal>
                    </div>

                )}
                {(state === '2' || statedos === '2') && (

                    <div className="col-md-12">
                        <label>Inventario de Mercancia</label>
                        <BasicTable body={lista} head={headinventariomercacia} rowSet={generalinfobycost.setBean} listButtons={listaBotonesinventariomercancia()} iconButtons={iconButtonsIteminventario}></BasicTable>
                        <Modal modal={verdoc} updateModal={setVerdoc}>
                            <>
                                <NationalizationSupport Nationalization={generalinfobycost.bean.IDNationalizationProcessGeneralInfo} />
                            </>
                        </Modal>
                        <Modal modal={modaleditarinventariomercancia} updateModal={setModaleditarinventariomercancia} eventModal={editaItem}>
                            <>
                                <div className="row">
                                    {/* {contract && <>
                                        <div className="col-md-12">
                                            <label>Contrato</label>
                                            <input type="text" name="ContractDescription" className="form-control" value={generalinfobycost.bean.ContractDescription} onChange={generalinfobycost.handleChange} />

                                        </div>
                                    </>}
                                    {donation && <>
                                        <div className="col-md-12">
                                            <label>Proyecto</label>
                                            <input type="text" name="ProjectDescription" className="form-control" value={generalinfobycost.bean.ProjectDescription} onChange={generalinfobycost.handleChange} />

                                        </div>
                                    </>} */}

                                    <div className="col-md-6">
                                        <label>Deposito de la mercancia</label>
                                        <input type="text" name="DepositINVM" className="form-control" value={generalinfobycost.bean.DepositINVM} onChange={generalinfobycost.handleChange} />
                                    </div>
                                    <div className="col-md-6">
                                        <label>Lugar</label>
                                        <input type="text" name="PlaceINVM" className="form-control" value={generalinfobycost.bean.PlaceINVM} onChange={generalinfobycost.handleChange} />
                                    </div>
                                    <div className="col-md-6">
                                        <InputDate name="DateINVM" label="Fecha" value={generalinfobycost.bean.DateINVM} setDate={(e: any) => { generalinfobycost.setBean({ ...generalinfobycost.bean, "DateINVM": e }) }} />
                                    </div>
                                    <div className="col-md-6">
                                        <label>Documento de Trasporte</label>
                                        <input type="text" name="NoDocTransport" className="form-control" value={generalinfobycost.bean.NoDocTransport} onChange={generalinfobycost.handleChange} />
                                    </div>
                                    <div className="col-md-6">
                                        <label>Numero de manifiesto de la carga</label>
                                        <input type="text" name="NoManifiestINVM" className="form-control" value={generalinfobycost.bean.NoManifiestINVM} onChange={generalinfobycost.handleChange} />
                                    </div>

                                    <div className="col-md-6">
                                        <InputDate name="ManifestDateINVM" label="Fecha de ingreso de mercancía" value={generalinfobycost.bean.ManifestDateINVM} setDate={(e: any) => { generalinfobycost.setBean({ ...generalinfobycost.bean, "ManifestDateINVM": e }) }} />
                                    </div>
                                    {/* <div className="col-md-6">
                                        <label>No. Inventarios de mercancía que se generan</label>
                                        <input type="text" name="NoInvetoryINVM" className="form-control" value={generalinfobycost.bean.NoInvetoryINVM} onChange={generalinfobycost.handleChange} />
                                    </div> */}

                                    <div className="col-md-12">
                                        <label>Asunto</label>
                                        <textarea name="DelegateINVM" className="form-control" value={generalinfobycost.bean.DelegateINVM} onChange={(e) => { generalinfobycost.setBean({ ...generalinfobycost.bean, 'DelegateINVM': e.target.value }) }} />
                                    </div>
                                    <div className="col-md-12">
                                        <label>Peso en bruto de la mercancia</label>
                                        <input type="text" name="GrossWeightINVM" className="form-control" value={generalinfobycost.bean.GrossWeightINVM} onChange={generalinfobycost.handleChange} />
                                    </div>
                                    {/* <div className="col-md-6">
                                        <FileInput
                                            Media={generalinfobycost.bean.Media}
                                            MediaContext={generalinfobycost.bean.MediaContext}
                                            directory='registrophoto'
                                            label='Registros fotográficos de la mercancía'
                                            onCreate={({ MediaContext, Media }: any) => { generalinfobycost.setBean({ ...generalinfobycost.bean, "PhotographEvidenceINVM": JSON.stringify({ MediaContext: MediaContext, Media: Media }) }); }}
                                        ></FileInput>

                                        <div className="col-md-6">
                                            <FileInput
                                                Media={generalinfobycost.bean.Media}
                                                MediaContext={generalinfobycost.bean.MediaContext}
                                                directory='registrophoto'
                                                label='Registros fotográficos de la mercancía'
                                                onCreate={({ MediaContext, Media }: any) => { generalinfobycost.setBean({ ...generalinfobycost.bean, "PhotographEvidenceINVM2": JSON.stringify({ MediaContext: MediaContext, Media: Media }) }); }}
                                            ></FileInput>

                                        </div>
                                        <div className="col-md-6">
                                            <FileInput
                                                Media={generalinfobycost.bean.Media}
                                                MediaContext={generalinfobycost.bean.MediaContext}
                                                directory='registrophoto'
                                                label='Registros fotográficos de la mercancía'
                                                onCreate={({ MediaContext, Media }: any) => { generalinfobycost.setBean({ ...generalinfobycost.bean, "PhotographEvidenceINVM3": JSON.stringify({ MediaContext: MediaContext, Media: Media }) }); }}
                                            ></FileInput>

                                            <div className="col-md-6">

                                                <FileInput
                                                    Media={generalinfobycost.bean.Media}
                                                    MediaContext={generalinfobycost.bean.MediaContext}
                                                    directory='registrophoto'
                                                    label='Registros fotográficos de la mercancía'
                                                    onCreate={({ MediaContext, Media }: any) => { generalinfobycost.setBean({ ...generalinfobycost.bean, "PhotographEvidenceINVM4": JSON.stringify({ MediaContext: MediaContext, Media: Media }) }); }}
                                                ></FileInput>

                                            </div>
                                            <div className="col-md-6">
                                                <InputDate name="IncomeMerchandiseDateINVM" label="Fecha de ingreso de la mercancia" value={generalinfobycost.bean.IncomeMerchandiseDateINVM} setDate={(e: any) => { generalinfobycost.setBean({ ...generalinfobycost.bean, "IncomeMerchandiseDateINVM": e }) }} />
                                            </div>
                                            <div className="col-md-6">
                                                <AccountEditor idAccount={generalinfobycost.bean.MadeByINVM} label="PERSONA/USUARIO que elabora el inventario de la mercancia" onChange={(acc: any) => { generalinfobycost.setBean({ ...generalinfobycost.bean, "MadeByINVM": acc.IDAccount }); }} />
                                            </div>
                                            <div className="col-md-6">
                                                <AccountEditor idAccount={generalinfobycost.bean.ReviewedByINVM} label="PERSONAL/USUARIO que realiza la revisión del inventario de la mercancía" onChange={(acc: any) => { generalinfobycost.setBean({ ...generalinfobycost.bean, "ReviewedByINVM": acc.IDAccount }); }} />
                                            </div> */}
                                    <div className="col-md-12">
                                        <label>Observaciones</label>

                                        <textarea name="ObservationsINVM" className="form-control" value={generalinfobycost.bean.ObservationsINVM} onChange={(e) => { generalinfobycost.setBean({ ...generalinfobycost.bean, 'ObservationsINVM': e.target.value }) }} />
                                    </div>
                                </div>
                                {/* {generalinfobycost.bean.IDNationalizationProcessGeneralInfo &&
                                    <>
                                        <div className="row">
                                            <NationalizationProcessItemsByStoreProduct IDNationalizationProcessGeneralInfo={generalinfobycost.bean.IDNationalizationProcessGeneralInfo} />
                                        </div>
                                    </>
                                } */}
                            </>
                        </Modal>
                        <Modal modal={modalrep} updateModal={setModalrep} eventModal={editaItem}>
                            <>
                                <div className="col-md-12">
                                    <BasicButton icon="" eventClick={() => { descargarReporte(1) }}>Inventario de Mercancia</BasicButton>
                                    {pathfile != '' &&
                                        <div className="col-md-12">
                                            <a href={pathfile} target="_blank">Descargar Archivo</a>
                                        </div>
                                    }
                                </div>

                            </>
                        </Modal>
                        <Modal modal={modalitemsinventario} updateModal={setModalitemsinventario}>
                            <>
                                <div className="row">
                                    <div className="col-md-12">
                                        <NationalizationProcessItemsByStoreProduct IDNationalizationProcessGeneralInfo={generalinfobycost.bean.IDNationalizationProcessGeneralInfo} />
                                    </div>

                                </div>
                            </>
                        </Modal>
                    </div>
                )}

                {statedos == 3 && (
                    <div className="col-md-12">
                        <label>Liquidacion de Costos</label>
                        <BasicTable body={lista} head={headliquidacion} rowSet={generalinfobycost.setBean} listButtons={listaBotonesliquiedacion()}></BasicTable>
                        <Modal modal={verdoc} updateModal={setVerdoc}>
                            <>
                                <NationalizationSupport Nationalization={generalinfobycost.bean.IDNationalizationProcessGeneralInfo} />
                            </>
                        </Modal>
                        <Modal modal={modaleditarliquidacion} updateModal={setModaleditarliquidacion} eventModal={editaItem}>
                            <>

                                <div className="row">
                                    {/* {contract && <>
                                        <div className="col-md-12">
                                            <label>Contrato</label>
                                            <input type="text" name="ContractDescription" className="form-control" value={generalinfobycost.bean.ContractDescription} onChange={generalinfobycost.handleChange} />

                                        </div>
                                    </>}
                                    <div className="col-md-6">
                                        <label>No. Documento Transporte</label>
                                        <input type="text" name="NoDocTransport" className="form-control" value={generalinfobycost.bean.NoDocTransport} onChange={generalinfobycost.handleChange} />
                                    </div> */}
                                    {/* <div className="col-md-6">
                                        <InputDate name="LiquidationCostDateLC" label="Fecha de liquidacion de costos de la importacion" value={generalinfobycost.bean.LiquidationCostDateLC} setDate={(e: any) => { generalinfobycost.setBean({ ...generalinfobycost.bean, "LiquidationCostDateLC": e }) }} />
                                    </div> */}
                                    {/* <div className="col-md-6">
                                        <label>Liquidaciones de costos realizadas</label>
                                        <input type="text" name="NoLiquidationLC" className="form-control" value={generalinfobycost.bean.NoLiquidationLC} onChange={generalinfobycost.handleChange} />
                                    </div> */}
                                    <div className="col-md-12">
                                        <CurrencyEditor id={generalinfobycost.bean.CurrencyType} onchange={(e: any) => { generalinfobycost.setBean({ ...generalinfobycost.bean, "CurrencyType": e }) }}></CurrencyEditor>
                                    </div>
                                    {/* <div className="col-md-6">
                                        // 
                                        <AccountEditor idAccount={generalinfobycost.bean.ReviewedByLC} label="PERSONA/USUARIO QUE HACE LA REVISION DE LIQUIDACION DE COSTOS" onChange={(acc: any) => { generalinfobycost.setBean({ ...generalinfobycost.bean, "ReviewedByLC": acc.IDAccount }); }} />
                                    </div>
                                    <div className="col-md-6">
                                        <AccountEditor idAccount={generalinfobycost.bean.MadeByLC} label="PERSONA O USUARIO QUE REALIZA LA LIQUIDACION DE COSTOS" onChange={(acc: any) => { generalinfobycost.setBean({ ...generalinfobycost.bean, "MadeByLC": acc.IDAccount }); }} />
                                    </div> */}
                                </div>
                                {/* {generalinfobycost.bean.IDNationalizationProcessGeneralInfo &&
                                    <>
                                        <div className="row">
                                            <NationalizationProcessItemsByLiquidation IDNationalizationProcessGeneralInfo={generalinfobycost.bean.IDNationalizationProcessGeneralInfo} />
                                        </div>
                                    </>
                                } */}
                            </>
                        </Modal>
                        <Modal modal={modalrep} updateModal={setModalrep} eventModal={editaItem}>
                            <>
                                <div className="col-md-12">
                                    <BasicButton icon="" eventClick={() => { descargarReporte(3) }}>Liquidacion de Costos</BasicButton>
                                    {pathfile != '' &&
                                        <div className="col-md-12">
                                            <a href={pathfile} target="_blank">Descargar Archivo</a>
                                        </div>
                                    }
                                </div>

                            </>
                        </Modal>
                        <Modal modal={modalitemsliquidacion} updateModal={setModalitemsliquidacion}>
                            <>
                                <div className="row">
                                    <div className="col-md-12">
                                        <NationalizationProcessItemsByLiquidation IDNationalizationProcessGeneralInfo={generalinfobycost.bean.IDNationalizationProcessGeneralInfo} />
                                    </div>
                                </div>
                            </>
                        </Modal>
                    </div>

                )}

                {(state === '4' || statedos === '4') && (
                    <div className="col-md-12">
                        <label>Declaración de importación</label>
                        <BasicTable body={lista} head={headdeclaracionimp} rowSet={generalinfobycost.setBean} listButtons={listaBotonesdeclaracionimp()} iconButtons={iconButtonsItemdelaracion}></BasicTable>
                        <Modal modal={verdoc} updateModal={setVerdoc}>
                            <>
                                <NationalizationSupport Nationalization={generalinfobycost.bean.IDNationalizationProcessGeneralInfo} />
                            </>
                        </Modal>
                        <Modal modal={modaleditardeclaracionimp} updateModal={setModaldeclaracionimp} eventModal={editaItem}>
                            <>


                                <div className="row">
                                    {contract && <>
                                        <div className="col-md-12">
                                            <label>Contrato</label>
                                            <input type="text" name="ContractDescription" className="form-control" value={generalinfobycost.bean.ContractDescription} onChange={generalinfobycost.handleChange} />

                                        </div>
                                    </>}
                                    {donation && <>
                                        <div className="col-md-12">
                                            <label>Proyecto</label>
                                            <input type="text" name="ProjectDescription" className="form-control" value={generalinfobycost.bean.ProjectDescription} onChange={generalinfobycost.handleChange} />

                                        </div>
                                    </>}
                                    <div className="col-md-6">
                                        <label>No. Documento Transporte</label>
                                        <input type="text" name="NoDocTransport" className="form-control" value={generalinfobycost.bean.NoDocTransport} onChange={generalinfobycost.handleChange} />
                                    </div>
                                    <div className="col-md-6">
                                        <label>Número de declaración de Importación</label>
                                        <input type="text" name="NoDeclartionImportDMStr" className="form-control" value={generalinfobycost.bean.NoDeclartionImportDMStr} onChange={(e: any) => { generalinfobycost.setBean({ ...generalinfobycost.bean, "NoDeclartionImportDMStr": e.target.value }) }} />
                                    </div>
                                    <div className="col-md-6">
                                        <label>Tasa de cambio</label>
                                        <input type='text' name="ExchangeRate" className="form-control" value={generalinfobycost.bean.ExchangeRate} onChange={generalinfobycost.handleChange} />
                                    </div>
                                    <div className="col-md-6">
                                        <InputDate name="DateEM" label="Fecha de declaración de importación" value={generalinfobycost.bean.ImportDeclarationDateDM} setDate={(e: any) => { generalinfobycost.setBean({ ...generalinfobycost.bean, "ImportDeclarationDateDM": e }) }} />
                                    </div>
                                    <div className="col-md-6">
                                        <AccountEditor idAccount={generalinfobycost.bean.MadeByDM} label="usuario/persona que elabora la declaracion de importación" onChange={(acc: any) => { generalinfobycost.setBean({ ...generalinfobycost.bean, "MadeByDM": acc.IDAccount }); }} />
                                    </div>
                                    <div className="col-md-6">
                                        <AccountEditor idAccount={generalinfobycost.bean.ReviewedByDM} label="usuario/persona que revisa la declaracion de importación" onChange={(acc: any) => { generalinfobycost.setBean({ ...generalinfobycost.bean, "ReviewedByDM": acc.IDAccount }); }} />
                                    </div>
                                    <div className="col-md-12">
                                        <label>Observaciones</label>

                                        <textarea name="ObservationsDM" className="form-control" value={generalinfobycost.bean.ObservationsDM} onChange={(e) => { generalinfobycost.setBean({ ...generalinfobycost.bean, 'ObservationsDM': e.target.value }) }} />
                                    </div>

                                </div>
                                {/* {generalinfobycost.bean.IDNationalizationProcessGeneralInfo &&
                                    <>
                                        <div className="row">
                                            <NationalizationProcessItemsByImportDM IDNationalizationProcessGeneralInfo={generalinfobycost.bean.IDNationalizationProcessGeneralInfo} />
                                        </div>
                                    </>
                                } */}
                            </>
                        </Modal>
                        <Modal modal={modalrep} updateModal={setModalrep} eventModal={editaItem}>
                            <>
                                <div className="col-md-12">
                                    <BasicButton icon="" eventClick={() => { descargarReporte(5) }}>Declaracion de importacion</BasicButton>
                                    {pathfile != '' &&
                                        <div className="col-md-12">
                                            <a href={pathfile} target="_blank">Descargar Archivo</a>
                                        </div>
                                    }
                                </div>


                            </>
                        </Modal>
                        <Modal modal={modalitemsdeclaracion} updateModal={setModalitemsdeclaracion}>
                            <>
                                <div className="row">
                                    <div className="col-md-12">
                                        <NationalizationProcessItemsByImportDM IDNationalizationProcessGeneralInfo={generalinfobycost.bean.IDNationalizationProcessGeneralInfo} />
                                    </div>
                                </div>
                            </>
                        </Modal>
                    </div>

                )}

                {(state === '5' || statedos === '5') && (
                    <div className="col-md-12">
                        <label>Acta de entrega de mercancia</label>
                        <BasicTable body={lista} head={headacta} rowSet={generalinfobycost.setBean} listButtons={listaBotonesacta()} ></BasicTable>
                        <Modal modal={verdoc} updateModal={setVerdoc}>
                            <>
                                <NationalizationSupport Nationalization={generalinfobycost.bean.IDNationalizationProcessGeneralInfo} />
                            </>
                        </Modal>
                          <Modal modal={modalverimage} updateModal={setModalverimage}>
                          <></>
                        </Modal>
                        <Modal modal={modaleditaracta} updateModal={setModaleditaracta} eventModal={editaItem}>
                            <>
                                <div className="row">
                                    {contract && <>
                                        <div className="col-md-12">
                                            <label>Contrato</label>
                                            <input type="text" name="ContractDescription" className="form-control" value={generalinfobycost.bean.ContractDescription} onChange={generalinfobycost.handleChange} />

                                        </div>
                                    </>}
                                    <div className="col-md-6">
                                        <label>No. Documento Transporte</label>
                                        <input type="text" name="NoDocTransport" className="form-control" value={generalinfobycost.bean.NoDocTransport} onChange={generalinfobycost.handleChange} />
                                    </div>
                                    {/* <div className="col-md-6">
                                        <label>No. Acta de entrega de mercancia</label>
                                        <input type="text" name="NoDeliveryActEM" className="form-control" value={generalinfobycost.bean.NoDeliveryActEM} onChange={generalinfobycost.handleChange} />
                                    </div> */}
                                    <div className="col-md-6">
                                        <InputDate name="DateEM" label="Fecha de registro de Entrega de Mercancia" value={generalinfobycost.bean.DateEM} setDate={(e: any) => { generalinfobycost.setBean({ ...generalinfobycost.bean, "DateEM": e }) }} />
                                    </div>
                                    <div className="col-md-6">
                                        <label>Deposito de entrega de Mercancia</label>
                                        <input type="text" name="DepositEM" className="form-control" value={generalinfobycost.bean.DepositEM} onChange={generalinfobycost.handleChange} />
                                    </div>
                                    <div className="col-md-6">
                                        <label>Dirección de entrega de Mercancia</label>
                                        <input type="text" name="AdressEM" className="form-control" value={generalinfobycost.bean.AdressEM} onChange={generalinfobycost.handleChange} />
                                    </div>
                                    <div className="col-md-6">
                                        <InputDate name="DeliveryDateEM" label="Fecha de Entrega de la Mercancia" value={generalinfobycost.bean.DeliveryDateEM} setDate={(e: any) => { generalinfobycost.setBean({ ...generalinfobycost.bean, "DeliveryDateEM": e }) }} />
                                    </div>
                                    {/* <div className="col-md-6">
                                        <label>Peso Bruto de entrega de mercancia</label>
                                        <input type="text" name="GrossWeightEM" className="form-control" value={generalinfobycost.bean.GrossWeightEM} onChange={generalinfobycost.handleChange} />
                                    </div> */}
                                    {/* <div className="col-md-6">
                                        <FileInput
                                            Media={generalinfobycost.bean.Media}
                                            MediaContext={generalinfobycost.bean.MediaContext}
                                            directory='registrophoto'
                                            label='Registro fotográfico de la entrega de la mercancia'
                                            
                                            onCreate={({ MediaContext, Media }: any) => { generalinfobycost.setBean({ ...generalinfobycost.bean, "PhographEvidenceEM": JSON.stringify({ MediaContext: MediaContext, Media: Media }) }); }}
                                        ></FileInput>
                                    </div>
                                    <div className="col-md-6">
                                        <FileInput
                                            Media={generalinfobycost.bean.Media}
                                            MediaContext={generalinfobycost.bean.MediaContext}
                                            directory='registrophoto'
                                            label='Registro fotográfico de la entrega de la mercancia'
                                            
                                            onCreate={({ MediaContext, Media }: any) => { generalinfobycost.setBean({ ...generalinfobycost.bean, "PhographEvidenceEM2": JSON.stringify({ MediaContext: MediaContext, Media: Media }) }); }}
                                        ></FileInput>
                                    </div>
                                    <div className="col-md-6">
                                        <FileInput
                                            Media={generalinfobycost.bean.Media}
                                            MediaContext={generalinfobycost.bean.MediaContext}
                                            directory='registrophoto'
                                            label='Registro fotográfico de la entrega de la mercancia'
                                            
                                            onCreate={({ MediaContext, Media }: any) => { generalinfobycost.setBean({ ...generalinfobycost.bean, "PhographEvidenceEM3": JSON.stringify({ MediaContext: MediaContext, Media: Media }) }); }}
                                        ></FileInput>
                                    </div>
                                    <div className="col-md-6">
                                        <FileInput
                                            Media={generalinfobycost.bean.Media}
                                            MediaContext={generalinfobycost.bean.MediaContext}
                                            directory='registrophoto'
                                            label='Registro fotográfico de la entrega de la mercancia'
                                          
                                            onCreate={({ MediaContext, Media }: any) => { generalinfobycost.setBean({ ...generalinfobycost.bean, "PhographEvidenceEM4": JSON.stringify({ MediaContext: MediaContext, Media: Media }) }); }}
                                        ></FileInput>
                                    </div> */}
                                    <div className="col-md-12">
                                        <label>Observaciones</label>

                                        <textarea name="ObservationsEM" className="form-control" value={generalinfobycost.bean.ObservationsEM} onChange={(e) => { generalinfobycost.setBean({ ...generalinfobycost.bean, 'ObservationsEM': e.target.value }) }} />
                                    </div>

                                </div>
                                {/* {generalinfobycost.bean.IDNationalizationProcessGeneralInfo &&
                                    <>
                                        <div className="row">
                                            <NationalizationProcessItemsByActStore IDNationalizationProcessGeneralInfo={generalinfobycost.bean.IDNationalizationProcessGeneralInfo} />
                                        </div>
                                    </>
                                } */}
                            </>
                        </Modal>
                        <Modal modal={modalrep} updateModal={setModalrep} eventModal={editaItem}>
                            <>
                                <div className="col-md-12">
                                    <BasicButton icon="" eventClick={() => { descargarReporte(4) }}>Acta de entrega de mercancia</BasicButton>
                                    {pathfile != '' &&
                                        <div className="col-md-12">
                                            <a href={pathfile} target="_blank">Descargar Archivo</a>
                                        </div>
                                    }
                                </div>

                            </>
                        </Modal>
                        <Modal modal={modalitemsacta} updateModal={setModalitemsacta}>
                            <>
                                <div className="row">
                                    <div className="col-md-12">
                                        <NationalizationProcessItemsByActStore IDNationalizationProcessGeneralInfo={generalinfobycost.bean.IDNationalizationProcessGeneralInfo} />
                                    </div>
                                </div>
                            </>
                        </Modal>
                    </div>


                )}
                {(state === '6' || statedos === '6') && (
                    <div className="col-md-12">
                        <label>Acta de entrega descargue directo</label>
                        <BasicTable body={lista} head={headactaescarguedirecto} rowSet={generalinfobycost.setBean} listButtons={listaActadirecciondescargue()} ></BasicTable>
                        <Modal modal={verdoc} updateModal={setVerdoc}>
                            <>
                                <NationalizationSupport Nationalization={generalinfobycost.bean.IDNationalizationProcessGeneralInfo} />
                            </>
                        </Modal>
                        <Modal modal={modaldirecto} updateModal={setModaldirecto} eventModal={editaItem}>
                            <>

                                <div className="row">
                                    {/* <PrintJson json={costestudy.bean} /> */}
                                    {contract && <>
                                        <div className="col-md-12">
                                            <label>Contrato</label>
                                            <input type="text" name="ContractDescription" className="form-control" value={generalinfobycost.bean.ContractDescription} onChange={generalinfobycost.handleChange} />

                                        </div>
                                    </>}
                                    <div className="col-md-6">
                                        <label>No. Documento Transporte</label>
                                        <input type="text" name="NoDocTransport" className="form-control" value={generalinfobycost.bean.NoDocTransport} onChange={generalinfobycost.handleChange} />
                                    </div>
                                    {/* <div className="col-md-6">
                                        <label>Tasa</label>
                                        <input type='text' name="ExchangeRate" className="form-control" value={generalinfobycost.bean.ExchangeRate} onChange={generalinfobycost.handleChange} />
                                    </div> */}
                                    <div className="col-md-6">
                                        <CurrencyEditor id={generalinfobycost.bean.CurrencyType} onchange={(e: any) => { generalinfobycost.setBean({ ...generalinfobycost.bean, "CurrencyType": e }) }}></CurrencyEditor>
                                    </div>

                                    <div className="col-md-6">
                                        <label>Ciudad de entrega de descargue directo</label>
                                        <input type="text" name="CityEDD" className="form-control" value={generalinfobycost.bean.CityEDD} onChange={generalinfobycost.handleChange}  />
                                        {/* <SelectSiteID label="Ciudad de entrega de descargue directo" edit idLnSite={generalinfobycost.bean.CityEDD} onChange={(e) => { generalinfobycost.setBean({ ...generalinfobycost.bean, "CityEDD": e.Name }) }} /> */}
                                    </div>
                                    <div className="col-md-6">
                                        <InputDate name="DateEDD" label="Fecha de entrega de descargue directo" value={generalinfobycost.bean.DateEDD} setDate={(e: any) => { generalinfobycost.setBean({ ...generalinfobycost.bean, "DateEDD": e }) }} />
                                    </div>
                                    <div className="col-md-6">
                                        <label>Grado del Almacenista</label>
                                        <input type='text' name="StorekeeperEDD" className="form-control" value={generalinfobycost.bean.StorekeeperEDD} onChange={generalinfobycost.handleChange} />
                                    </div>
                                    <div className="col-md-6">
                                        <label>Nombre del Almacenista</label>
                                        <input type='text' name="AccountStr" className="form-control" value={generalinfobycost.bean.AccountStr} onChange={generalinfobycost.handleChange} />
                                    </div>
                                    <div className="col-md-6">
                                        <label>Profesión y Nombre de Coordinador (a) Grupo de Comercio Exterior</label>
                                        <input type='text' name="CoordinationExteriorComerceEDD" className="form-control" value={generalinfobycost.bean.CoordinationExteriorComerceEDD} onChange={generalinfobycost.handleChange} />
                                    </div>
                                </div>
                                {/* {generalinfobycost.bean.IDNationalizationProcessGeneralInfo &&
                                    <>
                                        <div className="row">
                                            <NationalizationProcessItemsBydescarguedirecto IDNationalizationProcessGeneralInfo={generalinfobycost.bean.IDNationalizationProcessGeneralInfo} />
                                        </div>
                                    </>
                                } */}
                            </>
                        </Modal>
                        <Modal modal={modalrep} updateModal={setModalrep} eventModal={editaItem}>
                            <>
                                <div className="col-md-12">
                                    <BasicButton icon="" eventClick={() => { descargarReporte(6) }}>Acta de entrega descargue directo</BasicButton>
                                    {pathfile != '' &&
                                        <div className="col-md-12">
                                            <a href={pathfile} target="_blank">Descargar Archivo</a>
                                        </div>
                                    }
                                </div>

                            </>
                        </Modal>
                        <Modal modal={modalitemsdescargue} updateModal={setModalitemsdescargue}>
                            <>
                                <div className="row">
                                    <div className="col-md-12">

                                        <NationalizationProcessItemsBydescarguedirecto IDNationalizationProcessGeneralInfo={generalinfobycost.bean.IDNationalizationProcessGeneralInfo} />
                                    </div>
                                </div>

                            </>
                        </Modal>
                    </div>

                )}
                {/* <div className="col-md-12">
                    <label>Declaración de exportación</label>
                    <BasicTable body={lista} head={headdeclaracionexp} rowSet={generalinfobycost.setBean} listButtons={listaBotones()} ></BasicTable>
                </div> */}

                <div className="col-md-12">
                    <ModalConfirm modal={modalC} updateModal={setModalC} eventModal={deleteItem}>
                        <strong>Eliminar item {generalinfobycost.bean.Name}</strong>
                    </ModalConfirm>
                </div>
                <div className="col-md-12">
                    <Modal modal={modalGraph.modal} updateModal={modalGraph.setModal}>
                        <AutoChart data={lista} head={headcostoestudio} useIndexAsXLabel={true}
                            xOptions={['IDAdquisitionContract', 'DateEC', 'DepositEM', 'paymentMethodName']}
                            yOptions={['ExchangeRate', 'DeliveryDeadlineEC', 'GrossWeightEM']} />

                    </Modal>
                    <Modal modal={modalGraphdos.modal} updateModal={modalGraphdos.setModal}>
                        <AutoChart data={lista} head={headinventariomercacia} useIndexAsXLabel={true}
                            xOptions={['IDAdquisitionContract', 'NoDocTransport']}
                            yOptions={['NoManifiestINVM', 'NoInvetoryINVM']} />

                    </Modal>
                    <Modal modal={modalGraphtres.modal} updateModal={modalGraphtres.setModal}>
                        <AutoChart data={lista} head={headliquidacion} useIndexAsXLabel={true}
                            xOptions={['IDAdquisitionContract', 'NoDocTransport']}
                            yOptions={['', 'NoLiquidationLC']} />
                    </Modal>
                    <Modal modal={modalGraphcuatro.modal} updateModal={modalGraphcuatro.setModal}>
                        <AutoChart data={lista} head={headacta} useIndexAsXLabel={true}
                            xOptions={['IDAdquisitionContract', 'NoDocTransport']}
                            yOptions={['DepositEM', 'NoDeliveryActEM']} />
                    </Modal>
                    <Modal modal={modalGraphcinco.modal} updateModal={modalGraphcinco.setModal}>
                        <AutoChart data={lista} head={headdeclaracionimp} useIndexAsXLabel={true}
                            xOptions={['IDAdquisitionContract', 'NoDocTransport']}
                            yOptions={['', 'NoDeclartionImportDM']} />

                    </Modal>
                </div>
                <div className="col-md-12">
                    <Modal modal={modalGraphcinco.modal} updateModal={modalGraphcinco.setModal}>
                        <>

                        </>

                    </Modal>
                </div>

            </div>
        </BasicPage>
    )
}